import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function ChecklistSection() {
  const phases = [{
    days: 'Days 1-3',
    action: 'Nerve Discharge 2x/day + Protein before Coffee',
    goal: 'Signal Safety'
  }, {
    days: 'Days 4-7',
    action: 'Add Mineral Mocktail at 3 PM',
    goal: 'Prevent Crash'
  }, {
    days: 'Days 8-10',
    action: 'Implement 3-2-1 Sleep Rule',
    goal: 'Reset Circadian'
  }, {
    days: 'Days 11-14',
    action: "Monitor 'Cortisol Face' in mirror",
    goal: 'Visible Results'
  }];
  return <section className="py-20 lg:py-32 px-6 bg-white" data-id="element-9">
      <div className="max-w-4xl mx-auto" data-id="element-10">
        <div className="text-center mb-16" data-id="element-11">
          <span className="text-gold font-serif italic text-xl mb-4 block" data-id="element-12">
            Chapter 6
          </span>
          <h2 className="text-4xl lg:text-5xl font-serif text-charcoal mb-6" data-id="element-13">
            14-Day Action Checklist
          </h2>
          <p className="text-lg text-charcoal/80" data-id="element-14">
            Small, strategic changes stacked over two weeks.
          </p>
        </div>

        <div className="bg-cream rounded-lg overflow-hidden shadow-sm border border-cream-dark" data-id="element-15">
          <div className="hidden md:grid grid-cols-12 bg-sage text-white py-4 px-6 font-serif text-lg" data-id="element-16">
            <div className="col-span-3" data-id="element-17">Timeline</div>
            <div className="col-span-6" data-id="element-18">Action</div>
            <div className="col-span-3 text-right" data-id="element-19">Goal</div>
          </div>

          <div className="divide-y divide-cream-dark" data-id="element-20">
            {phases.map((phase, index) => <div key={index} className="grid grid-cols-1 md:grid-cols-12 p-6 md:py-8 md:px-6 gap-4 md:gap-0 items-center hover:bg-white transition-colors" data-id="element-21">
                <div className="col-span-3 flex items-center gap-3" data-id="element-22">
                  <div className="w-8 h-8 rounded-full bg-sage/10 flex items-center justify-center text-sage font-bold text-sm" data-id="element-23">
                    {index + 1}
                  </div>
                  <span className="font-bold text-charcoal" data-id="element-24">{phase.days}</span>
                </div>
                <div className="col-span-6 text-charcoal/80 font-medium" data-id="element-25">
                  {phase.action}
                </div>
                <div className="col-span-3 md:text-right flex items-center md:justify-end gap-2 text-gold font-serif italic" data-id="element-26">
                  <CheckCircle2 className="w-4 h-4" data-id="element-27" />
                  {phase.goal}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}